import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function NoMatch() {
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  return (
    <div>
      <p>Oops! No page found!</p>
      <div>
        <button onClick={goBack}>go Back</button>
      </div>
    </div>
  );
}
